import React from "react";
import {ReactComponent as EditIcon} from "../../../assets/icons/edit.svg";
import {ReactComponent as CancelIcon} from "../../../assets/icons/cancel.svg";
import {ReactComponent as EyeIcon} from "../../../assets/icons/eye.svg";
import {ReactComponent as BookIcon} from "../../../assets/icons/class_online.svg";
import {ReactComponent as TickIcon} from "../../../assets/icons/eye.svg";
import styled from "styled-components";
import {ResetButton} from "../../../styles/Butttons";

export const ToggleStyle = styled.div`
   width: 2em;
   height: 1em;
   border-radius: 0.5em;
   background-color: rgba(100, 100, 100, 0.4);
   position: relative;
   transition: all 420ms;

   &:after {
      content: "";
      background-color: white;
      position: absolute;
      top: 0.05em;
      left: 0;
      height: 0.9em;
      width: 0.9em;
      border-radius: 50%;
      transition: all 420ms;
   }

   &.ON {
      background-color: green;
      transition: all 420ms;

      &:after {
         left: calc(100% - 1em);
         // right: 0;
         transition: all 420ms;
      }
   }
   &.OFF {
      background-color: grey;
      transition: all 420ms;
   }
`;

export function ToggleButton({action, status}) {
   return (
      <td className="actionBtn">
         <ResetButton onClick={action}>
            <ToggleStyle className={!status ? "OFF" : "ON"} />
         </ResetButton>
      </td>
   );
}
export function EditButton({action}) {
   return (
      <td className="actionBtn">
         <ResetButton onClick={action}>
            <EditIcon width="1.3em" height="1.3em" />
         </ResetButton>
      </td>
   );
}

export function ShowButton({action}) {
   return (
      <td className="actionBtn">
         <ResetButton onClick={action}>
            <BookIcon width="1.3em" height="1.3em" />
         </ResetButton>
      </td>
   );
}

export function SeeButton({action}) {
   return (
      <td className="actionBtn">
         <ResetButton onClick={action}>
            <EyeIcon width="1.3em" height="1.3em" />
         </ResetButton>
      </td>
   );
}

export function DeleteButton({action}) {
   return (
      <td className="actionBtn">
         <ResetButton onClick={action}>
            <CancelIcon width="1.3em" height="1.3em" fill="crimson" />
         </ResetButton>
      </td>
   );
}
export function ActivateButton({action}) {
   return (
      <td className="actionBtn">
         <ResetButton onClick={action}>
            <CancelIcon width="1.3em" height="1.3em" fill="green" />
         </ResetButton>
      </td>
   );
}
